import React from 'react';

import cx from 'classnames';
import {
  CtaEventDataType,
  CTA_TYPES,
  trackCtaClicked,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import { Link } from '@zola/zola-ui/src/components/Link';

import TextUtil from 'util/TextUtil';
import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';
import { BusinessUnit } from '@zola-helpers/client/dist/es/@types';

import css from './NavMarketingModuleAsBgImage.module.less';
import type { NavMarketingModuleAsBgImageMapStateProps } from '.';

type NavMarketingModuleAsBgImageProps = NavMarketingModuleAsBgImageMapStateProps & {
  activeNavType: PrimaryNavIdentifier;
  businessUnit?: BusinessUnit;
  imageSize?: '570x324' | '354x302';
  className?: string;
};

const NavMarketingModuleAsBgImage = ({
  marketingModules = [],
  activeNavType,
  businessUnit,
  imageSize = '354x302',
  className,
}: NavMarketingModuleAsBgImageProps): JSX.Element | null => {
  const buildCtaEventData = (index: number): CtaEventDataType => {
    const mod = marketingModules[index];
    return {
      business_unit: businessUnit,
      cta_type: CTA_TYPES.MARKETING_MODULE_LARGE,
      group_id: 'PRIMARY_SUB_MENU',
      cta_id: TextUtil.toAllUpperCase(activeNavType),
      position: index + 1,
      location: 'PRIMARY_SUB_MENU',
      section: TextUtil.toAllUpperCase(activeNavType),
      cta: mod.link_path,
    };
  };

  const handleCtaClick = (i: number) => {
    const eventData = buildCtaEventData(i);
    trackCtaClicked(eventData);
  };

  if (!marketingModules.length) return null;

  return (
    <div className={cx(className, css.container)}>
      {marketingModules.map((module, i) => (
        <Link
          key={i}
          className={cx(css.module, css[`module_${module.title}`])}
          href={module.link_path}
          onClick={() => handleCtaClick(i)}
        >
          <div
            className={css.bgImage}
            style={{ backgroundImage: `url(${module.images_by_dimension?.[imageSize]})` }}
          >
            <div className={css.textContainer}>
              <div className={css.title}>{module.subtitle}</div>
              <span className={css.linkText}>{module.link_label}</span>
              <i className={cx(css.arrow, 'zola-ui-icon zola-ui-icon-link-arrow')} />
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default NavMarketingModuleAsBgImage;
